"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadCSVWidget = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var papaparse_1 = __importDefault(require("papaparse"));
var react_redux_1 = require("react-redux");
var main_1 = require("../../../reducers/slices/main");
var upload_lots_csv_1 = require("../../../api/calls/lot/v3/upload_lots_csv");
var UploadCSVWidget = function (props) {
    var onSave = props.onSave;
    var dispatch = (0, react_redux_1.useDispatch)();
    var mainAuction = (0, react_redux_1.useSelector)(function (state) { return state.consoleState; }).mainAuction;
    var _a = (0, react_1.useState)([]), records = _a[0], setRecords = _a[1];
    (0, react_1.useEffect)(function () {
        //     console.log("records", records);
    }, [records]);
    return (react_1.default.createElement("div", { className: "min-h-96 max-h-screen flex flex-col gap-4" },
        react_1.default.createElement("div", { className: "flex-none flex flex-col gap-4" },
            react_1.default.createElement(doshx_controls_web_1.FileInputControl, { label: "Select CSV", supportedFileTypes: [".csv"], size: "small", onChange: function (f) {
                    //             console.log("FileInputControl onChange", f);
                    papaparse_1.default.parse(f, {
                        delimiter: ";",
                        header: true,
                        skipEmptyLines: "greedy",
                        complete: function (results) {
                            setRecords(results.data.map(function (result) {
                                //                     console.log("result", result);
                                // Gather the possible keys
                                var lotNumKey = Object.keys(result).find(function (key) {
                                    var k = key.toLowerCase();
                                    return k === "#" || k === "num" || k === "no";
                                });
                                var titleKey = Object.keys(result).find(function (key) {
                                    var k = key.toLowerCase();
                                    return k === "title/heading" || k === "title" || k === "heading";
                                });
                                var descriptionKey = Object.keys(result).find(function (key) {
                                    var k = key.toLowerCase();
                                    return k === "description/history" || k === "description" || k === "history";
                                });
                                // let startingPriceKey = Object.keys(result).find((key) => key.toLowerCase() === "starting price");
                                var yearKey = Object.keys(result).find(function (key) { return key.toLowerCase() === "year"; });
                                var colourKey = Object.keys(result).find(function (key) { return key.toLowerCase() === "colour"; });
                                var mileageKey = Object.keys(result).find(function (key) { return key.toLowerCase() === "mileage"; });
                                var transmissionKey = Object.keys(result).find(function (key) { return key.toLowerCase() === "transmission"; });
                                var fuelKey = Object.keys(result).find(function (key) { return key.toLowerCase() === "fuel"; });
                                // Build the fields from the keys
                                var fields = {};
                                if (lotNumKey) {
                                    fields.lot_number = result[lotNumKey];
                                }
                                if (titleKey) {
                                    fields.title = result[titleKey];
                                }
                                if (descriptionKey) {
                                    fields.description = result[descriptionKey];
                                }
                                // Build the extra data from the keys
                                fields.extra_data = [];
                                if (yearKey) {
                                    fields.extra_data.push({ key: "Year", value: result[yearKey] });
                                }
                                if (colourKey) {
                                    fields.extra_data.push({ key: "Colour", value: result[colourKey] });
                                }
                                if (mileageKey) {
                                    fields.extra_data.push({ key: "Mileage", value: result[mileageKey] });
                                }
                                if (transmissionKey) {
                                    fields.extra_data.push({ key: "Transmission", value: result[transmissionKey] });
                                }
                                if (fuelKey) {
                                    fields.extra_data.push({ key: "Fuel", value: result[fuelKey] });
                                }
                                // Return the formatted records
                                return __assign({}, fields);
                            }));
                        },
                    });
                }, colors: {
                    iconColor: "text-purple-500",
                    borderColor: "border-red-500",
                    // backgroundColor: "bg-red-500",
                    placeholderColor: "text-yellow-500",
                    textColor: "text-blue-800",
                } }),
            records && records.length > 0 && (react_1.default.createElement("div", null,
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Save These Lots", onClick: function () {
                        //                 console.log("records", records);
                        (0, upload_lots_csv_1.upload_lots_csv)({
                            auction_entity_id: mainAuction.entity_id,
                            records: records,
                        }).then(function (response) {
                            if (response.data.success) {
                                onSave && onSave();
                                // onClose && onClose();
                                // dispatch(setMessageModal(null));
                            }
                            else {
                                dispatch((0, main_1.setMessageModal)({ title: "OOPS!", messages: [response.data.message] }));
                            }
                        });
                    } })))),
        react_1.default.createElement("div", { className: "flex-none max-h-64 pb-4 overflow-visible" },
            react_1.default.createElement(doshx_controls_web_1.TableControl, { title: "Records", columns: [
                    { label: "#", displayKey: "lot_number" },
                    { label: "Title/Heading", displayKey: "title" },
                    { label: "Description/History", displayKey: "description" },
                    {
                        label: "Year",
                        displayKey: "",
                        formatter: function (o) {
                            var _a;
                            return (_a = o.extra_data.find(function (d) { return d.key === "Year"; })) === null || _a === void 0 ? void 0 : _a.value;
                        },
                    },
                    { label: "Colour", displayKey: "", formatter: function (o) { var _a; return (_a = o.extra_data.find(function (d) { return d.key === "Colour"; })) === null || _a === void 0 ? void 0 : _a.value; } },
                    { label: "Mileage", displayKey: "", formatter: function (o) { var _a; return (_a = o.extra_data.find(function (d) { return d.key === "Mileage"; })) === null || _a === void 0 ? void 0 : _a.value; } },
                    { label: "Transmission", displayKey: "", formatter: function (o) { var _a; return (_a = o.extra_data.find(function (d) { return d.key === "Transmission"; })) === null || _a === void 0 ? void 0 : _a.value; } },
                    { label: "Fuel", displayKey: "", formatter: function (o) { var _a; return (_a = o.extra_data.find(function (d) { return d.key === "Fuel"; })) === null || _a === void 0 ? void 0 : _a.value; } },
                ], data: records }))));
};
exports.UploadCSVWidget = UploadCSVWidget;
